import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/PWDReq.module.css";
import { LanguageContext } from "../../Context/changeLanguageProvider";
function PasswordRequirements({ req, containerStyle }) {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang.content.PasswordRequirements.passwordRequirements
  );
  useEffect(() => {
    setContent(
      websiteCurrentLang.content.PasswordRequirements.passwordRequirements
    );
  }, [websiteCurrentLang]);
  return (
    <ul className={styles.card} style={containerStyle ? containerStyle : {}}>
      <div className={styles.password_title}>
        {content.signupPasswordRequirmentTitle}
      </div>
      <li className={req?.length ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText1}
      </li>
      <li className={req?.digits ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText2}
      </li>
      <li className={req?.lower ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText3}
      </li>
      <li className={req?.upper ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText4}
      </li>
      <li className={req?.special ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText5.replaceAll("`", '"')}
      </li>
      <li className={req?.passmatch ? styles.filled : styles.notfilled}>
        {content.signupPasswordRequirmentText6}
      </li>
    </ul>
  );
}

export default PasswordRequirements;
